module.exports = __webpack_public_path__ + "static/media/slideImg5.8ab02183.png";